import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const ItemHeaderCell = memo(
  ({
    title,
    itemId,
    itemNo,
    style,
    canDelete,
    onDeletePress,
  }: {
    title: string;
    itemId?: number;
    itemNo: number;
    style?: StyleProp<ViewStyle>;
    canDelete?: boolean;
    onDeletePress?: () => void;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    return (
      <View style={style}>
        <Center
          css={`
            padding: 0 ${rpx(20)}px;
            height: ${rpx(40)}px;
          `}
        >
          <Typography.Label size={rpx(18)} light>
            {title}
          </Typography.Label>
          {__DEV__ && itemId != null ? (
            <Typography.Label
              light
              size={rpx(10)}
              lineHeight={rpx(14)}
              color="#888"
              css={`
                position: absolute;
                top: ${rpx(13)}px;
                right: 0;
              `}
            >{`#${itemId}`}</Typography.Label>
          ) : null}
        </Center>
        <View
          css={`
            position: absolute;
            left: ${rpx(15)}px;
            top: 0;
            bottom: 0;
            justify-content: center;
          `}
        >
          <Typography.Label
            size={rpx(18)}
            medium
          >{`Q${itemNo}`}</Typography.Label>
        </View>
        {canDelete ? (
          <TouchableOpacity
            onPress={onDeletePress}
            css={`
              position: absolute;
              right: 0;
              top: 0;
              bottom: 0;
              justify-content: center;
              padding: 0 ${rpx(8)}px;
            `}
          >
            <Icon
              name="trash-o"
              size={rpx(20)}
              color={theme.colors.status.danger}
            />
          </TouchableOpacity>
        ) : null}
      </View>
    );
  },
);
